import { createElement as rc, useMemo, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Button, Icon } from 'lib_ui-primitives';
import { Draggable, Label } from './styles';
import { useTheme } from 'styled-components';

//Key to limit dragging onto other droppable areas 9and vice versa:
export const DRAGGABLE_TYPE = 'column-configuration';

export function DraggableRow(props) {
    const { id, entry, onChange, onClick, index } = props;
    const theme = useTheme();
    const ref = useRef(null);
    const [{ isDragging }, dragRef] = useDrag(
        () => ({
            type: DRAGGABLE_TYPE,
            item: { entry, index },
            collect: monitor => ({
                isDragging: !!monitor.isDragging()
            })
        }),
        []
    );
    const [{ isOver }, dropRef] = useDrop(
        () => ({
            accept: DRAGGABLE_TYPE,
            collect: monitor => ({
                isOver: !!monitor.isOver()
            }),
            drop: item => {
                if (!ref.current) {
                    return;
                }
                const dragId = item.entry.id;
                const dropId = entry.id;
                // Don't replace items with themselves
                if (dragId === dropId) {
                    return;
                }

                // perform the actual action
                onChange(dragId, dropId);
            }
        }),
        [index, entry]
    );
    // todo: GL2025 we don't _need_ this when we are on the new theme.
    const [dragIcon, eyeIcon] = useMemo(() => {
        const dragIcon = theme?.selectedTheme === 'gl2025' ? 'drag' : 'drag_indicator';
        let eyeIcon = theme?.selectedTheme === 'gl2025' ? 'eye' : 'visibility';
        if (entry.hidden) {
            eyeIcon = theme?.selectedTheme === 'gl2025' ? 'eye-off' : 'visibility_off';
        }
        return [dragIcon, eyeIcon];
    }, [entry.hidden, theme?.selectedTheme]);
    //make dropRef and dragRef both point to ref:
    dropRef(dragRef(ref));

    return rc(
        Draggable,
        { id, ref, isDragging, isOver, title: 'Drag up or down to adjust column order' },
        rc(Icon, { color: entry.hidden ? theme.disabledFontColor : theme.defaultFontColor }, dragIcon),
        rc(Label, { color: entry.hidden ? theme.disabledFontColor : theme.defaultFontColor }, entry.title || '...'),
        rc(Button, {
            id: `visibility${entry.id}`,
            name: 'search-icon-container',
            buttonStyle: 'round',
            roundDiameter: 32,
            color: entry.hidden ? 'base' : 'accentOne',
            icon: eyeIcon,
            variant: 'tertiary',
            onClick: () => onClick(index)
        })
    );
}
